import React from 'react';
import DepartmentOverviewTopRow from '../portal/DepartmentOverviewTopRow';
import DepartmentWhatsNewCard from '../portal/DepartmentWhatsNewCard';
import HRHiringStatusCard from './HRHiringStatusCard';

const HRAllTab = () => {
  return (
    <div>
      {/* Community & Roadmap (with current task) */}
      <DepartmentOverviewTopRow category="hr" showGoals={false} />

      {/* What's New (left) · Hiring Status (right) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DepartmentWhatsNewCard department="hr" />
        <HRHiringStatusCard />
      </div>
    </div>
  );
};

export default HRAllTab;
